import { z } from 'zod/v4-mini';

import { GeneralBackendResponseSchema } from '$/services/mapper/authentication';

export const UserSchema = z.pipe(
  z.object({
    id: z.string(),
    email: z.string(),
    firstname: z.string(),
    lastname: z.string(),
    role: z._default(
      z.enum([
        'free',
        'pro',
        'keyUser', //'pro + keyUser für neue Features',
        'superAdmin',
        'countryAdmin',
        'student',
        'teacher',
        'superTeacher',
      ]),
      'pro',
    ),
    managedCountries: z._default(z.array(z.string()), []),
    lastActivity: z.nullable(z.string()),
    isActiveAdmin: z._default(z.boolean(), false),
    poEditorPermissions: z._default(z.array(z.string()), []),
    country: z.nullable(z.string()),
    schoolId: z.optional(z.string()),
    classId: z.optional(z.string()),
    expirationDate: z.optional(z.string()),
  }),
  z.transform((data) => ({
    ...data,
    firstName: data.firstname,
    lastName: data.lastname,
  })),
);

export type User = z.infer<typeof UserSchema>;

export const RegistrationResponseSchema = z.pipe(
  z.object({
    ...GeneralBackendResponseSchema,
    payload: z.optional(z.object({ user: UserSchema, otpToken: z.string() })),
  }),
  z.transform((data) => {
    return {
      message: data.message,
      user: data.payload?.user,
      otpToken: data.payload?.otpToken,
    };
  }),
);
